'use client'

import { useEffect } from "react"
import { Sponsors } from "@/(front-desk)/(pages)/sponsor/page"
import Marquee from "@/(front-desk)/components/Marquee"
import Banner from "@/(front-desk)/(pages)/(home)/(components)/Banner"
import Judges from "@/(front-desk)/(pages)/(home)/(components)/Judges"
import News from "@/(front-desk)/(pages)/(home)/(components)/News"
import Link from "next/link"
import AOS from 'aos'
import background from "@/(front-desk)/assets/images/background/default.png"
import 'aos/dist/aos.css'

export default function Home() {

    useEffect(() => {
        AOS.init()
    }, [])

    return (
        <>
        <title>首頁 - 放視大賞</title>
        <main className="home flex-center flex-col">
            <div className="
                banner !h-[calc(85vh-var(--navbar-height)-var(--marquee-height))
                sm:!h-[calc(100vh-var(--navbar-height)-var(--marquee-height))
            ">
                <Banner />
            </div>
            <Marquee />
            <div className="news w-full">
                <div className="news-content w-full pt-12 pb-12 sm:pt-24 sm:pb-24">
                    <News />
                    <Link className="btn-main-700 btn-round w-full" href="/news/all">
                        更多消息
                    </Link>
                </div>
            </div>

            <div className="judges w-full" data-aos="fade-up">
                <div className="judges-content w-full pt-12 pb-12 sm:pt-24 sm:pb-24">
                    <Judges />
                </div>
            </div>
            
            <div className="sponsor relative w-full flex-center flex-col py-[2.5rem] sm:py-[5rem]" data-aos="fade-up">
                <div className="text-center -mb-[2.5rem] sm:-mb-[5rem]">
                    {/* <div className="text-[2rem] text-white font-bold">Sponsor</div> */}
                    <div className="text-[3rem] text-white font-bold">熱情贊助</div>
                </div>
                <Sponsors />
            </div>
        </main>
        </>
    )
}
